import {Grey17, Grey6} from "../../theme/styles";

import {EnlilTable2} from "../EnlilTable2";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {IconButton, Chip, Menu, MenuItem, Typography, Tooltip} from "@mui/material";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import EventBus from "../../util/EventBus";
import ProjectPlanPhaseMilestoneReferenceFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseMilestoneReferenceFormApplet";
import {ControlPoint, DeleteForever, Edit, Info, MoreVert, Refresh} from "@mui/icons-material";
import {hasPrivilege} from "../../util/SessionContext";
import css_link from "../Common/css/Link.module.scss";

class ProjectPlanPhaseMilestoneReferenceTable extends EnlilTable2 {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("project-plan-phase-milestone-reference-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-reference-form-applet-save", this.onCancelHandler);
    };

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("project-plan-phase-milestone-reference-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("project-plan-phase-milestone-reference-form-applet-save", this.onCancelHandler);
    };

    getCellRenderer(name) {
        if (name === "State Cell") {
            return this.renderStateCell;
        } else if (name === "Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Action Cell") {
            return this.renderActionCell;
        } else if (name === "D2M Hyperlink Cell") {
            return this.renderD2MHyperLinkCell;
        } else if (name === "Approval Request Hyperlink Cell") {
            return this.renderApprovalRequestHyperLinkCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "Add Reference") {
            this.setState({renderTarget: "Add Reference"});
        }
        super.handleMenuClick(identifier);
    }

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderExtension() {
        if (this.state.renderTarget === "Add Reference") {
            return <ProjectPlanPhaseMilestoneReferenceFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New"/>;
        }
        if (this.state.renderTarget === "Edit Reference") {
            return <ProjectPlanPhaseMilestoneReferenceFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Edit"/>;
        }
        if (this.state.renderTarget === "Delete Reference") {
            return <ProjectPlanPhaseMilestoneReferenceFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete"/>;
        }
    };

    getAddReferenceTooltip() {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("ProjectPlanPhaseStatus") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
        if (hasPrivilege("ADD_MILESTONE_REFERENCE") === false) {
            return "This feature is disabled because you do not have the 'Add Milestone Reference' privilege in any of your assigned roles."
        }
    }

    renderMenuContent() {
        let menuItems = [];

        menuItems.push(
            <MenuItem key={"menuItem1"} onClick={(e) => {
                if (hasPrivilege("ADD_MILESTONE_REFERENCE") && this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("ProjectPlanPhaseStatus") !== "DONE") {
                    e.stopPropagation();
                    this.handleMenuClick("Add Reference");
                    this.setState({showMenu: false});
                } else {
                    // do nothing
                }
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <ControlPoint sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Add Reference
                {!hasPrivilege("ADD_MILESTONE_REFERENCE") || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("Status") === "DONE" || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseMilestone").getAttributeValue("ProjectPlanPhaseStatus") === "DONE" ? (
                    <div style={{marginLeft: "10px", marginTop: "6px"}}>
                        <Tooltip title={this.getAddReferenceTooltip()}>
                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                        </Tooltip>
                    </div>
                ) : null}
            </MenuItem>
        );
        menuItems.push(
            <MenuItem key={"menuItem2"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("Refresh");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <Refresh sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Refresh
            </MenuItem>
        );

        return menuItems;
    };

    renderStateCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let backgroundColor;
        let content;
        if (this.state.buffer[params.row.id].get("DisplayStatus") === "Draft" || this.state.buffer[params.row.id].get("DisplayStatus") === "Last Signed" || this.state.buffer[params.row.id].get("DisplayStatus") === "WIP") {
            backgroundColor = "#DCF4FD";
            content = <Chip id="1" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #457AB5", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#457AB5", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else if (this.state.buffer[params.row.id].get("DisplayStatus") === "Pending Change" || this.state.buffer[params.row.id].get("DisplayStatus") === "Pending Approval" || this.state.buffer[params.row.id].get("DisplayStatus") === "In Review") {
            backgroundColor = "#FEF8EE";
            content = <Chip id="1" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #B25F00", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#B25F00", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else if (this.state.buffer[params.row.id].get("DisplayStatus") === "Released" || this.state.buffer[params.row.id].get("DisplayStatus") === "Approved") {
            backgroundColor = "#E6FCD9"
            content = <Chip id="2" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #509849", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#509849", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else {
            content = <Typography style={{marginTop: "10px"}}>{this.state.buffer[params.row.id].get("DisplayStatus")}</Typography>
        }
        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "100%"}}>
                {content}
            </div>
        );
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let status;

        if (this.state.buffer[params.row.id].get("DocumentTypeGroup") === "PO") {
            status = this.state.buffer[params.row.id].get("PurchaseOrderStatus");
        } else if (this.state.buffer[params.row.id].get("DocumentTypeGroup") === "LOT") {
            status = this.state.buffer[params.row.id].get("LotStatus");
        } else if (this.state.buffer[params.row.id].get("DocumentTypeGroup") === "EQUIPMENT") {
            status = this.state.buffer[params.row.id].get("EquipmentStatus");
        } else {
            status = "--";
        }
        return (
            <div>
                <Typography style={{fontSize: "14px", marginTop: "7px"}}>{status}</Typography>
            </div>
        );
    };

    renderApprovalRequestHyperLinkCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let link;
        if (process.env.REACT_APP_ENLIL_ENV === "prod") {
            link = "https://enlil.io/change_request/" + this.state.buffer[params.row.id].get("ApprovalRequestUSID") + "/preview"
        } else {
            link = "https://" + process.env.REACT_APP_ENLIL_ENV + ".enlil.io/change_request/" + this.state.buffer[params.row.id].get("ApprovalRequestUSID") + "/preview"
        }

        return (
            <div>
                <Typography style={{fontSize: "14px", marginTop: "7px"}}><a className={css_link.link} href={link} rel="noreferrer" target="_blank">{this.state.buffer[params.row.id].get("ApprovalRequestID")}</a></Typography>
            </div>
        );
    };

    renderD2MHyperLinkCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let link;
        if (process.env.REACT_APP_ENLIL_ENV === "prod") {
            link = "https://enlil.io/document_revision/" + this.state.buffer[params.row.id].get("DocumentUSID") + "/version/" + this.state.buffer[params.row.id].get("DocumentRevisionUSID")
        } else {
            link = "https://" + process.env.REACT_APP_ENLIL_ENV + ".enlil.io/document_revision/" + this.state.buffer[params.row.id].get("DocumentUSID") + "/version/" + this.state.buffer[params.row.id].get("DocumentRevisionUSID")
        }

        return (
            <div>
                <Typography style={{fontSize: "14px", marginTop: "7px"}}><a className={css_link.link} href={link} rel="noreferrer" target="_blank">{this.state.buffer[params.row.id].get("DocumentID")}</a></Typography>
            </div>
        );
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px"}}>
                <IconButton className={css_buttons.tableOptionButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        if (hasPrivilege("EDIT_MILESTONE_REFERENCE") && this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") !== "DONE" && (this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") !== "DONE" || this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") !== null)) {
                            this.setState({tableActionMenuTarget: null, renderTarget: "Edit Reference"});
                        }
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Reference</Typography>
                        {!hasPrivilege("EDIT_MILESTONE_REFERENCE") || this.state.buffer[params.row.id].get("MilestoneStatus") === "DONE" || this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? (
                            <div style={{marginTop: "6px"}}>
                                <Tooltip title={this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? "This feature is disabled because the Phase is 'DONE'." : this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") === "DONE" ? "This feature is disabled because the milestone status is 'DONE'." : "This feature is disabled because you do not have the 'Edit Milestone Reference' privilege in any of your assigned roles."}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                    <MenuItem divider key={"2"} className={css_self.Standard} onClick={() => {
                        if (hasPrivilege("DELETE_MILESTONE_REFERENCE") && this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") !== "DONE" && this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") !== "DONE") {
                            this.setState({tableActionMenuTarget: null, renderTarget: "Delete Reference"});
                        }
                    }}>
                        <DeleteForever style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Reference</Typography>
                        {!hasPrivilege("DELETE_MILESTONE_REFERENCE") || this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") === "DONE" || this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? (
                            <div style={{marginTop: "6px"}}>
                                <Tooltip title={this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? "This feature is disabled because the Phase is 'DONE'." : this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") === "DONE" ? "This feature is disabled because the milestone status is 'DONE'." : "This feature is disabled because you do not have the 'Delete Milestone Reference' privilege in any of your assigned roles."}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ProjectPlanPhaseMilestoneReferenceTable)));